// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2_9Qh","addWidgetButton":"Header_addWidgetButton__2k9g9","dashboardTabs":"Header_dashboardTabs__sSl9h","active":"Header_active__3eQfS"};